// extracted by mini-css-extract-plugin
export default {"control":"S0Z8AQ1uC8","light":"vdP1yqpq4l","dark":"P0X2xSTwPs","label":"UKp0tIsCsn"};